<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="converter.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div
            *ngIf="exchangeProtocolOptions?.length !== 1"
            class="field">
            <label class="font-medium required-field">Протокол обмена</label>
            <p-selectButton
              [options]="exchangeProtocolOptions"
              [(ngModel)]="converter.exchangeProtocol"
              optionLabel="label"
              optionValue="value"></p-selectButton>
            <small
              *ngIf="errors?.exchangeProtocol"
              class="p-error">
              {{ errors.exchangeProtocol | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Протокол считывателя карт</label>
            <p-selectButton
              [options]="readerProtocolOptions"
              [(ngModel)]="converter.readerProtocol"
              optionLabel="label"
              optionValue="value"></p-selectButton>
            <small
              *ngIf="errors?.readerProtocol"
              class="p-error">
              {{ errors.readerProtocol | join }}
            </small>
          </div>

          <div
            *ngIf="!(form$ | async).isEdit"
            class="field">
            <label class="font-medium required-field">Пароль</label>
            <p-password
              [feedback]="false"
              [toggleMask]="true"
              [(ngModel)]="converter['password']"
              [inputStyle]="{ width: '100%' }"
              styleClass="w-full"
              autocomplete="new-password">
            </p-password>
            <div class="mt-2 flex justify-content-end">
              <crm-button
                type="button"
                styleClass="p-button-outlined white-space-nowrap"
                label="Сгенерировать"
                (onClick)="generatePassword()"></crm-button>
            </div>
          </div>

          <div class="flex flex-column gap-2 mt-3">
            <div class="field-checkbox m-0">
              <p-checkbox
                [(ngModel)]="converter.invertEvents.controller"
                [binary]="true"
                inputId="controller"></p-checkbox>
              <label
                class="ml-2"
                [for]="'controller'">Инверсия контроллера</label>
            </div>

            <div class="field-checkbox m-0">
              <p-checkbox
                [(ngModel)]="converter.invertEvents.manualOpen"
                [binary]="true"
                inputId="manualOpen"></p-checkbox>
              <label
                class="ml-2"
                [for]="'manualOpen'">Инверсия кнопки</label>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveConverter()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete"
          label="Удалить"
          styleClass="p-button-danger p-button-outlined"
          (onClick)="deleteConverter()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
